import { RouletteBetType } from "../../../CustomComponents/RouletteBetType";

export class RouletteActions {
    static ActionSpin: string = "SPIN";
    static ActionSpinStop: string = "SPIN_STOP";
    static ActionAutoplay: string = "AUTOPLAY";
    static ActionSchemasToggle: string = "SCHEMAS_TOGGLE";
    static ActionAutoplayStop: string = "AUTOPLAY_STOP";
    static ActionDouble: string = "DOUBLE";
    static ActionRebet: string = "REBET";
    static ActionBetPlus: string = "BET_PLUS";
    static ActionBetMinus: string = "BET_MINUS";
    static ActionBetSelectValue: string = "BET_SELECT_VALUE_";
    static ActionBetBack: string = "BET_BACK";
    static ActionBetReset: string = "BET_RESET";
    static ActionRacetrackToggle: string = "RACETRACK_TOGGLE";
    static ActionRacetrackOn: string = "RACETRACK_ON";
    static ActionRacetrackOff: string = "RACETRACK_OFF";
    static ActionRacetrackNeighboursPlus: string = "RACETRACK_NEIGHBOURS_PLUS";
    static ActionRacetrackNeighboursMinus: string = "RACETRACK_NEIGHBOURS_MINUS";
    static ActionStatisticsToggle: string = "STATISTICS_TOGGLE";

    static ActionSchemasPlayerSelect: string = "SCHEMAS_PLAYER_SELECT";
    static ActionSchemasDefaultSelect: string = "SCHEMAS_DEFAULT_SELECT";
    static ActionSchemasDelete: string = "SCHEMAS_DELETE";
    static ActionSchemasSwitch: string = "SCHEMAS_SWITCH";

    //action name match protocol bet type + '_'
    static ActionBetSingle: string = RouletteBetType.Single + "_";
    static ActionBetSplitVertical: string = RouletteBetType.SplitVertical + "_";
    static ActionBetSplitHorizontal: string = RouletteBetType.SplitHorizontal + "_";
    static ActionBetStreet: string = RouletteBetType.Street + "_";
    static ActionBetCorner: string = RouletteBetType.Corner + "_";
    static ActionBetDoubleStreet: string = RouletteBetType.DoubleStreet + "_";
    static ActionBetTrio: string = RouletteBetType.Trio + "_";
    static ActionBetFirstFour: string = RouletteBetType.FirstFour + "_";
    static ActionBetBasket: string = RouletteBetType.Basket + "_";
    static ActionBetLowOrHigh: string = RouletteBetType.LowOrHigh + "_";
    static ActionBetRedOrBlack: string = RouletteBetType.RedOrBlack + "_";
    static ActionBetEvenOrOdd: string = RouletteBetType.EvenOrOdd + "_";
    static ActionBetDozen: string = RouletteBetType.Dozen + "_";
    static ActionBetColumn: string = RouletteBetType.Column + "_";

    static ActionRacetrackBet: string = "R_";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Actions/RouletteActions.ts
 **/